import { BankSearchController as controller } from './bankSearch.controller';
import template from './bankSearch.html';

export const bankSearchComponent = {
  restrict: 'E',
  bindings: {
    bindLabel: '@',
    delay: '@',
    form: '<',
    label: '@',
    messages: '<',
    model: '=',
    name: '@',
    onSelect: '&',
    options: '<',
    url: '@',
    value: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-bank-search/src/bankSearch.component.js